import useDocumentTitle from 'hooks/useDocumentTitle';
import React from 'react'

const VehicleType = () => {
  useDocumentTitle("Vehicle Type | T360");

  return (
    <div>VehicleType</div>
  )
}

export default VehicleType